export const ROUTE_PATH =
  '/merchant-reconciliation-receipts/merchant[eq]=:merchant_id';

export const ARCHIVE_ROUTE_PATH =
  '/reconciliation-receipts/reconciliation_id[eq]=:reconciliation_id';

export const FEATURE_NAME = 'merchantsReconciliationReceiptsPage';
